import { Stack, Typography, useTheme } from "@mui/material";
import { Button, ConfirmationBanner } from "components";
import { PRICING_COPY } from "./pricingContent";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

interface AiPriceCardProps {
  onCtaClick: () => void;
}

export const AiPriceCard = ({ onCtaClick }: AiPriceCardProps) => {
  const theme = useTheme();
  const { magenta } = theme.palette.primitive.system;
  const surface = theme.palette.neutral.main;

  return (
    <Stack
      sx={{
        gap: "24px",
        width: "100%",
        maxWidth: "561px",
        padding: "24px",
        border: "1px solid transparent",
        borderRadius: "22px",
        background: `linear-gradient(${surface}, ${surface}) padding-box, ${PRICING_DESIGN_VALUES.aiCardBorderGradient} border-box`,
        boxShadow: PRICING_DESIGN_VALUES.shadows.aiCard,
      }}
    >
      <ConfirmationBanner
        variant="info"
        variantStyles={{
          info: {
            backgroundColor: magenta[25],
            borderColor: magenta[400],
            iconColor: magenta[800],
          },
        }}
        containerStyle={{ p: "12px 16px", borderRadius: "8px" }}
        description={
          <Typography
            variant="body-medium"
            component="span"
            sx={{ color: magenta[800] }}
          >
            {PRICING_COPY.aiPilotNotice}
          </Typography>
        }
      />

      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="center"
        sx={{ gap: "24px" }}
      >
        <Typography
          variant="h64"
          component="span"
          sx={{ ...PRICING_DESIGN_VALUES.priceText, position: "relative" }}
        >
          {PRICING_COPY.aiPrice}
          {/* The struck price sits at the price's top-right (design screenshot 7). */}
          <Typography
            variant="body-small"
            component="span"
            sx={{
              ...PRICING_DESIGN_VALUES.aiOriginalPricePosition,
              position: "absolute",
              whiteSpace: "nowrap",
              color: theme.palette.lightBg.low,
              textDecoration: "line-through",
            }}
          >
            {PRICING_COPY.aiOriginalPrice}
          </Typography>
        </Typography>
        <Stack sx={{ gap: "4px" }}>
          <Typography
            variant="body-large"
            component="span"
            sx={{ color: theme.palette.lightBg.low }}
          >
            {PRICING_COPY.aiPeriod}
          </Typography>
          <Typography
            variant="body-xsmall"
            component="span"
            sx={{ color: theme.palette.lightBg.low }}
          >
            {PRICING_COPY.aiFootnote}
          </Typography>
        </Stack>
      </Stack>

      <Button
        variant="primary"
        fullWidth
        onClick={onCtaClick}
        sx={PRICING_DESIGN_VALUES.buttonOverrides}
      >
        {PRICING_COPY.talkToSales}
      </Button>
    </Stack>
  );
};
